/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum VesselDisposition {
  PORTSIDE = 'PORTSIDE',
  STARBOARD = 'STARBOARD',
}
